import { Locales } from '@griply/types';
import { formatISO } from 'date-fns';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type FinishUserSignupPayload = {
  name?: string;
  hasNotifications?: boolean;
  queryParameters?: Record<string, string>;
  locale?: Locales;
  source: string;
  _fprom_tid?: string;
};

type FinishUserSignupRequest = {
  name?: string;
  date: string;
  hasNotifications?: boolean;
  queryParameters: Record<string, string>;
  locale?: Locales;
  source: string;
  _fprom_tid?: string;
};

export type FinishUserSignupOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  payload: FinishUserSignupPayload;
};

export const finishUserSignup = async <TFunctions>(
  options: FinishUserSignupOptions<TFunctions>,
): Promise<void> => {
  const { functions, httpsCallable, payload } = options;
  const callable = httpsCallable<FinishUserSignupRequest, void>(
    functions,
    'users-finishSignup',
  );

  await callable({
    name: payload.name,
    date: formatISO(new Date()),
    hasNotifications: payload.hasNotifications,
    queryParameters: payload.queryParameters ?? {},
    locale: payload.locale,
    source: payload.source,
    _fprom_tid: payload._fprom_tid,
  });
};
